export default __webpack_public_path__ + "d496714b2051a71886c1bea77e32ed72.jpeg";